// removed by extract-text-webpack-plugin
module.exports = {"Rating":"_2nwf3d0ZExBEmxc9FnkSON","Star":"_1KEkLg8g02g6azMWOfiz6r","active":"FGX2-x2p__0NdMMJWJm3d","inactive":"_1lM89nw8nN0MEUR1HVikwM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Main/Rating.css
// module id = 1189
// module chunks = 0